export const card_1 = {
  'card_id':  'card_1', // 'ae9c7c88-5144-4e24-9974-932ad35947b2',
  'cardPhoneNumber': '+1 (305) 161-6161',
  'cardHolderEmail': 'james@travelbusinessclass.com',
  'postalCode': '19801',
  'street': '1007 N Orange St',
  'state': 'Delaware',
  'city': 'Wilmington',
  'country': 'United States',
  'cvv': '****',
  'expirationDate': '2050-11-30T22:00:00.000Z',
  'cardHolderName': 'sada',
  'cardNumber': '***************1111',
}

export const card_2 = {
  'card_id': 'card_2', //'ae9c7c88-5144-4e24-9974-932ad35947b2'
  'cardPhoneNumber': '+1 (305) 161-6161',
  'cardHolderEmail': 'james@travelbusinessclass.com',
  'postalCode': '19801',
  'street': '1007 N Orange St',
  'state': 'Delaware',
  'city': 'Wilmington',
  'country': 'United States',
  'cvv': '****',
  'expirationDate': '2050-11-30T22:00:00.000Z',
  'cardHolderName': 'sada',
  'cardNumber': '***************2222',
}

export const card_3 = {
  'card_id': 'card_3', //'ae9c7c88-5144-4e24-9974-932ad35947b2'
  'cardPhoneNumber': '+1 (305) 161-6161',
  'cardHolderEmail': 'james@travelbusinessclass.com',
  'postalCode': '19801',
  'street': '1007 N Orange St',
  'state': 'Delaware',
  'city': 'Wilmington',
  'country': 'United States',
  'cvv': '****',
  'expirationDate': '2050-11-30T22:00:00.000Z',
  'cardHolderName': 'sada',
  'cardNumber': '***************3333',
}

export const card_4 = {
  'card_id': 'card_4', //'ae9c7c88-5144-4e24-9974-932ad35947b2'
  'cardPhoneNumber': '+1 (305) 161-6161',
  'cardHolderEmail': 'james@travelbusinessclass.com',
  'postalCode': '19801',
  'street': '1007 N Orange St',
  'state': 'Delaware',
  'city': 'Wilmington',
  'country': 'United States',
  'cvv': '****',
  'expirationDate': '2050-11-30T22:00:00.000Z',
  'cardHolderName': 'sada',
  'cardNumber': '***************4444',
}
